// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2GCuv","subheader":"ReorderModal_subheader__2I7Wj","listWrap":"ReorderModal_listWrap__2EHK5"};